var exports = {
  "z": "x936d19a0--871b8d--unit",
};

module.exports = exports;
